import {Button, Image, RelativeSwitch, SortedTable} from "../components/common/common";
import {Route} from "react-router-dom";
import {formatPrice, relativePath, saveMessage, sortTable} from "../lib/tools";
import {reduxWrapper} from "../globalState";
import React, {Fragment} from "react";
import {
	FormInput,
	FormList,
	FormText,
	ImageUpload,
	ProductSelect,
	ValidateForm
} from "../components/common/formValidation";
import {getImage} from "../lib/api";


const BundlesTool = () => (
	<div id="bundlesTool">
		<RelativeSwitch>
			<Route path="/:id" render={({match: {params: {id}}}) => <BundleEdit id={id}/>}/>
			<Route path="/" render={() => <BundlesList/>}/>
		</RelativeSwitch>
	</div>
);

class BundleEditRender extends React.Component {
	constructor(props) {
		super(props);
		
		this.onSave = data => {
			this.props.apiCall("PUT", `/admin/products/bundle/${this.props.id}`, () => {
				this.props.sendMessage(saveMessage())
			}, data)
		};
	}
	
	componentWillMount() {
		this.props.apiCall("GET", `/products/bundle/${this.props.id}`, data => {
			this.setState(data);
			this.props.cacheProduct({products: data.products.map(x => x.id), all: true});
		});
	}
	
	render() {
		return (
			<div>
				<ValidateForm values={this.state} onChange={val => this.setState(val)} onSubmit={this.onSave}>
					<h2>Title</h2>
					<FormInput name="title" title=""/>
					
					<h2>Image</h2>
					<ImageUpload name="image"/>
					
					<h2>Includes</h2>
					<FormList name="includes">
						{
							({value, index, onChange}) =>
								<FormInput title="" name={index.toString()} value={value} onChange={onChange}/>
						}
					</FormList>
					
					<h2>Products</h2>
					<FormList name="products">
						{
							({value, index, onChange}) => (
								<Fragment>
									<ProductSelect value={value && value.id} onChange={val => onChange({...value, id: val})}/>
									<FormInput name="10" type="number" value={value ? value.qty10 : 0} onChange={val => onChange({...value, qty10: val})}/>
									<FormInput name="20" type="number" value={value ? value.qty20 : 0} onChange={val => onChange({...value, qty20: val})}/>
									<FormInput name="30" type="number" value={value ? value.qty30 : 0} onChange={val => onChange({...value, qty30: val})}/>
								</Fragment>
							)
						}
					</FormList>
					
					
					<h2>Description</h2>
					<FormText name="description"/>
					
					<h2>Short Description</h2>
					<FormText name="shortDescription" text/>
					
					<Button className="floatingBtn" submit>Save</Button>
				</ValidateForm>
			</div>
		);
	}
}

const BundleEdit = reduxWrapper("getApiCall", "getCacheProduct", "getSendMessage")(BundleEditRender);

class BundlesListRender extends React.Component {
	
	state = {
		bundles: []
	};
	
	bundles = [];
	
	componentWillMount() {
		this.props.apiCall("GET", "/products/bundles", bundles => {
			this.bundles = bundles;
			this.setState({bundles});
		});
	}
	
	tableChange({order, orderAsc}) {
		this.setState({bundles: sortTable(this.bundles, this.columns, order, orderAsc)});
	}
	
	columns = {
		id: {
			name: "ID",
			sortable: true
		},
		title: {
			name: "Title",
			sortable: true
		},
		image: {
			name: "Image",
			render: val => <Image src={getImage(val)}/>
		},
		price: {
			name: "Price",
			sortable: true,
			render: formatPrice
		},
		shortDescription: {
			name: "Short description"
		},
		products: {
			name: "Products",
			sortable: true,
			render: val => val.length,
			parse: val => val.length
		}
	};
	
	render() {
		return (
			<SortedTable
				columns={this.columns}
				rows={this.state.bundles}
				redirect={relativePath("") + "/"}
				redirectProp="id"
				onChange={val => this.tableChange(val)}
				history={this.props.history}
				pages={false}/>
		);
	}
}

const BundlesList = reduxWrapper("getApiCall")(BundlesListRender);

export default BundlesTool;


// WEBPACK FOOTER //
// ./src/admin/bundlesTool.js